module.exports = __webpack_public_path__ + "img/shop_front_2.02e9220b.jpg";